import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-sign-in-modal',
  templateUrl: './sign-in-modal.component.html',
  styleUrls: ['./sign-in-modal.component.scss']
})
export class SignInModalComponent {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public dialogRef: MatDialogRef<SignInModalComponent>,
    private router: Router
  ) {}

  goToLogin() {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem('afth_last_page', window.location.pathname);
    }
  
    this.dialogRef.close();
    this.router.navigate(['/sign-in']);
  }  

  close(): void {
    this.dialogRef.close();
  }
}
